import { z } from "zod";

const ManageUserAssignmentSchema = z.object({
	assignment: z
		.array(
			z.object({
				productId: z.number().min(1, "errors.product_id_required"),
				dhcId: z.number().min(1, "errors.dhc_id_required"),
				assignmentId: z.string(),
				isPaused: z.boolean().optional(),
			})
		)
		.superRefine((assignments, ctx) => {
			const seen = new Set<string>();

			assignments.forEach((item, index) => {
				if (item.productId && item.dhcId) {
					const key = `${item.productId}-${item.dhcId}`;

					if (seen.has(key)) {
						ctx.addIssue({
							code: "custom",
							message: "errors.duplicate_product_dhc",
							path: [index, "productId"],
						});
						ctx.addIssue({
							code: "custom",
							message: "errors.duplicate_product_dhc",
							path: [index, "dhcId"],
						});
					} else {
						seen.add(key);
					}
				}
			});
		}),
});

export type ManageUserAssignmentSchemaFormValues = z.infer<typeof ManageUserAssignmentSchema>;

export { ManageUserAssignmentSchema };
